import IconAsMaskImage from "../IconAsMaskImage";

const LeftArrow = ({ pureSvg, className, color }) => {
  const svg = (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.625 11.25L1.375 6L6.625 0.75"
        stroke="#851575"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
};

export default LeftArrow;
